import * as THREE from 'three';

/**
 * Animation loop with Three.js Clock and clamped delta.
 */
export class GameLoop {
  /**
   * @param {{
   *   onUpdate: (deltaSeconds: number) => void;
   *   onRender: () => void;
   *   maxDeltaSeconds?: number;
   * }} options
   */
  constructor({ onUpdate, onRender, maxDeltaSeconds = 0.1 }) {
    this._onUpdate = onUpdate;
    this._onRender = onRender;
    this._maxDelta = maxDeltaSeconds;
    this._running = false;
    this._rafId = 0;
    this.clock = new THREE.Clock();
  }

  start() {
    if (this._running) return;
    this._running = true;
    this.clock.start();
    this._tick = this._tick.bind(this);
    this._rafId = requestAnimationFrame(this._tick);
  }

  stop() {
    this._running = false;
    if (this._rafId) {
      cancelAnimationFrame(this._rafId);
      this._rafId = 0;
    }
    this.clock.stop();
  }

  _tick() {
    if (!this._running) return;

    let delta = this.clock.getDelta();
    if (delta > this._maxDelta) delta = this._maxDelta;

    this._onUpdate(delta);
    this._onRender();

    this._rafId = requestAnimationFrame(this._tick);
  }
}
